import { Card, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Box, Button, Stepper, IPropDetailContainer } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import Strings from "../../constants/strings";
import ChannelListContainer from "../channel";

import { Mode, Status } from "../../constants/enums";
import { Appearance, BasicInfo, CommunityImage } from "../../components/Community";
import { useData, useLanguage, useSelectData, useSubmit } from "../../hooks/community/edit";



const CommunityEditContainer = ({
    mode,
    idDetail,
    folderPath,
    onGoBack,
    onChangeMode,
}: { folderPath: string; } & IPropDetailContainer) => {
    const acUpdate = useMemo(() => !Helpers.isNullOrEmpty(idDetail), [idDetail]);

    const { language, setLanguage } = useLanguage();
    const { fontData, typeData } = useSelectData();
    const { data, error, setError, onChangeValue, handlePublish, handleUnpublish, onChangeSetting } = useData({ id: idDetail });
    const { onSubmit } = useSubmit({ data, mode, onGoBack, setError, onChangeMode, setLanguage });

    const acPublish = useMemo(() => {
        if (!Helpers.isNullOrEmpty(data.id) && mode === Mode.View && [Status.Inactive].includes(data.status)) return true;
        return false;
    }, [data, mode]);

    const acUnpublish = useMemo(() => {
        if (!Helpers.isNullOrEmpty(data.id) && mode === Mode.View && [Status.Active].includes(data.status)) return true;
        return false;
    }, [data, mode]);

    const [activeStep, setActiveStep] = useState(1);
    const [stepLabels, setStepLabels] = useState<string[]>([Strings.COMMUNITY.BASIC_INFO]);

    useEffect(() => {
        const newLable = [Strings.COMMUNITY.BASIC_INFO, Strings.CHANNEL.TITLE_MENU];
        setStepLabels(newLable);
    }, [data.id]);

    const renderCommunityCommponent = () => (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <BasicInfo
                    mode={mode}
                    data={data}
                    typeData={typeData}
                    language={language}
                    error={error}
                    setLanguage={setLanguage}
                    onChangeValue={onChangeValue}
                />
            </Grid>
            <Grid item xs={12}>
                <Appearance mode={mode} data={data} fontData={fontData} error={error} onChangeValue={onChangeSetting} />
            </Grid>
            <Grid item xs={12}>
                <CommunityImage mode={mode} data={data} folderPath={folderPath} error={error} onChangeValue={onChangeValue} />
            </Grid>
        </Grid>
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                {activeStep === 1 && (
                    <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "end", mb: 2 }}>
                        {Helpers.isFunction(onGoBack) && (
                            <Button color={"secondary"} onClick={onGoBack}>
                                {Strings.Common.GO_BACK}
                            </Button>
                        )}
                        {acUpdate && (
                            <Button sx={{ ml: 1 }} color={"dark"} onClick={onSubmit}>
                                {mode === Mode.View ? Strings.Common.EDIT : Strings.Common.SAVE}
                            </Button>
                        )}
                        {acPublish && (
                            <Button sx={{ ml: 1 }} color={"success"} onClick={handlePublish}>
                                {Strings.Common.PUBLISH}
                            </Button>
                        )}
                        {acUnpublish && (
                            <Button sx={{ ml: 1 }} color={"secondary"} onClick={handleUnpublish}>
                                {Strings.Common.STOP_PUBLISH}
                            </Button>
                        )}
                        {!acUpdate && mode === Mode.Create && (
                            <Button sx={{ ml: 1 }} color={"dark"} onClick={onSubmit}>
                                {Strings.Common.SAVE}
                            </Button>
                        )}
                    </Box>
                )}
                {activeStep === 2 && (
                    <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "end", mb: 2 }}>
                        <Button
                            color={"secondary"}
                            onClick={() => {
                                const val = activeStep - 1;
                                setActiveStep(val);
                            }}
                        >
                            {Strings.Common.GO_BACK}
                        </Button>
                    </Box>
                )}
            </Grid>
            <Grid item xs={12}>
                {Helpers.isNullOrEmpty(data.id) ? (
                    renderCommunityCommponent()
                ) : (
                    <div style={{ width: "100%" }}>
                        <Card square>
                            <Box width={"100%"} p={2}>
                                <Stepper
                                    hidenSequency
                                    stepLabels={stepLabels}
                                    activeStep={activeStep - 1}
                                    onStepChange={setActiveStep}
                                    canChangeStep={!Helpers.isNullOrEmpty(data.id)}
                                />
                            </Box>
                        </Card>
                        <Box mt={3}>
                            {activeStep === 1 && renderCommunityCommponent()}
                            {activeStep === 2 && (
                                <Card>
                                    <ChannelListContainer
                                        communityId={data.id}
                                        request={{
                                            pageNumber: 1,
                                            pageSize: 20,
                                        }}
                                    />
                                </Card>
                            )}
                        </Box>
                    </div>
                )}
            </Grid>
        </Grid>
    );
};

export default CommunityEditContainer;
